import axios from 'axios'
import debugHelper from '../../util/debug'
import { URLS } from '../../util/urls'
import tools from '../../util/tools'

const state = {
  /**
   * 文件Token
   */
  fstoken: new Object()
}

const getters = {
  getFstoken: state => {
    return state.fstoken.token
  }
}

const actions = {
  delFs: ({ commit }, params) => {
    debugHelper.log(URLS.FILE_BASE_URL + params.uri + '?token=' + params.token)
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: URLS.FILE_BASE_URL + params.uri + '?token=' + params.token,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          debugHelper.log('delFile => err' + err)
          err.type = 'error'
          err.prefix = 'file:'
          tools.showTips(this, err)
          reject()
          return
        })
    })
  },

  putFs: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: URLS.FS_PUT_URL + params.token,
        data: params.formdata,
        processData: false,
        traditional: true,
        contentType: false
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          debugHelper.log('file => sd' + err)
          err.type = 'error'
          err.prefix = 'file:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  putFsReceipt: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: URLS.FS_PUT_RECEIPT_URL + params.token,
        data: params.formdata,
        processData: false,
        traditional: true,
        contentType: false
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          debugHelper.log('file => sd' + err)
          err.type = 'error'
          err.prefix = 'file:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },

  fetchFsToken: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: URLS.FS_TOKEN_URL,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('updateFsToken', { value: resp.data })
          resolve()
        })
        .catch(err => {
          debugHelper.log('file => sd' + err)
          err.type = 'error'
          err.prefix = 'file:'
          tools.showTips(this, err)
          reject()
          return
        })
    })
  }
}

const mutations = {
  updateFsToken: (state, payload) => {
    state.fstoken = payload.value
  },
  requestErr: (state, payload) => {
    state.fstoken = payload.value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
